import {Text} from 'native-base';

export default Text;